
export const PondSprite = (
  <>
    <path
      fill="#754c24"
      d="M662.44 123.86C662.44 55.45 596.23 0 514.56 0H147.88C66.21 0 0 55.45 0 123.86V431c0 68.41 66.21 123.86 147.88 123.86h36.32c81.67 0 147.88 55.45 147.88 123.86 0 68.4 66.21 123.85 147.88 123.85h792.16c81.67 0 147.88-55.45 147.88-123.85V371.57c0-68.4-66.21-123.86-147.88-123.86h-461.8c-81.68 0-147.88-55.45-147.88-123.85z"
    />
    <path
      fill="#83c6c4"
      d="M662.44 156.72c0-68.41-66.21-123.86-147.88-123.86H147.88C66.21 32.86 0 88.31 0 156.72v307.11c0 68.4 66.21 123.85 147.88 123.85h36.32c81.67 0 147.88 55.45 147.88 123.86 0 68.4 66.21 123.86 147.88 123.86h792.16c81.67 0 147.88-55.46 147.88-123.86V404.43c0-68.4-66.21-123.85-147.88-123.85h-461.8c-81.68 0-147.88-55.46-147.88-123.86z"
    />
    <path
      fill="none"
      stroke="#3e4d5d"
      strokeWidth="2"
      d="M321.71 150.48a22.49 22.49 0 01-45 0 22.49 22.49 0 01-45 0 22.49 22.49 0 01-45 0M560.39 295.76a22.49 22.49 0 11-45 0 22.49 22.49 0 11-45 0 22.49 22.49 0 11-45 0M806 460.07a22.49 22.49 0 11-45 0 22.49 22.49 0 11-45 0 22.49 22.49 0 11-45 0M321.71 460.07a22.49 22.49 0 11-45 0 22.49 22.49 0 11-45 0 22.49 22.49 0 11-45 0M1247 460.07a22.49 22.49 0 11-45 0 22.49 22.49 0 11-45 0 22.49 22.49 0 11-45 0M1034.3 634.76a22.49 22.49 0 11-45 0 22.49 22.49 0 11-45 0 22.49 22.49 0 11-45 0M560.39 634.76a22.49 22.49 0 11-45 0 22.49 22.49 0 11-45 0 22.49 22.49 0 11-45 0"
      opacity="0.33"
    />
  </>
);
